/**
 * @ author kunnisser
 * @ date 2018/12/26
 * @ description: 设置mock数据接口
 */

import Axios from "axios";
import qs from "qs";

const TIMEOUT = 30e3;
// const FILETIMEOUT = 60e3;
const CancelToke = Axios.CancelToken;
const cancelReqs = [];
Axios.defaults.withCredentials = true;

const getMock = (url) => {
  return (params) => {
    return Axios.get(url, {
      params,
      cancelToken: new CancelToke((c) => {
        cancelReqs.push(c); // 注入cancelToke示例
      }),
      timeout: TIMEOUT,
      headers: {
        Authorization: window.sessionStorage.getItem("token"),
      },
    });
  };
};

const postMock = (url) => {
  return (params, locale) => {
    // let headers = {

    // }
    // if (locale) {
    //     headers = {
    //         ...headers,
    //         locale
    //     }
    // }
    return Axios.post(url, qs.stringify(params), {
      cancelToken: new CancelToke((c) => {
        cancelReqs.push(c);
      }),
      timeout: TIMEOUT,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: window.sessionStorage.getItem("token"),
        locale: locale || window.sessionStorage.getItem("locale"),
      },
    });
  };
};

// const fileMock = (url) => {
//   return (params) => {
//     return Axios.post(url, qs.stringify(params), {
//       timeout: FILETIMEOUT,
//       headers: {
//         'Content-Type': 'application/x-www-form-urlencoded'
//       }
//     });
//   }
// }

// v1.0.1 api
const APP_URL = process.env.REACT_APP_API_URL;
const prefixFile = APP_URL;
const Prefix = `${APP_URL}/api`;

/** **omc接口调用** */
const getUserMenuList = postMock(`${Prefix}/user/userMenuList`); // 菜单接口
/** ***充电成功率**** */
// 根据城市查询
const getChargSuccessCity = postMock(`${Prefix}/city/charg/success/rate`);
// 根据城市交直流查询
const getChargSuccessCityType = postMock(`${Prefix}/city/type/charg/success/rate`);
// 根据渠道查询
const getAppkeySuccessRate = postMock(`${Prefix}/appkey/charg/success/rate`);
// 固件版本数据
const getChargSuccessVersionType = postMock(`${Prefix}/versiontype/charg/success/rate`);
// 跳枪成功率
const getChargSuccessEndCode = postMock(`${Prefix}/endcode/charg/success/rate`);
// 设备完好率-桩运营类型分析
const getStubOperationModeList = postMock(`${Prefix}/stub/operationMode`);
// 设备完好率-城市完好率分析
const getStubCitySuccessRateList = postMock(`${Prefix}/stub/city/successRate`);
// 设备查询-获取设备型号列表
const getModelNoList = postMock(`${Prefix}/stub/modelNoList`);
// 设备查询-获取固件型号列表
const getFrameWorkList = postMock(`${Prefix}/stub/frameWorkList`);
// 设备查询-获取固件版本列表
const getUpdateTypeList = postMock(`${Prefix}/stub/updateTypeList`);
// 设备查询-获取设备列表
const getStubInfoList = postMock(`${Prefix}/stub/stubInfoList`);
// 设备查询-状态日志
const getStubStatuLogList = postMock(`${Prefix}/stub/statusList`);
// 设备查询-订单列表
const getStubOrderInfoList = postMock(`${Prefix}/stub/orderInfoList`);
// 设备查询-订单详情
const getStubOrderDetailInfo = postMock(`${Prefix}/stub/orderDetailInfo`);
// 配置管理接口
const getPowerBoxList = postMock(`${Prefix}/powerBox/list`);
const getPowerBoxDetail = postMock(`${Prefix}/powerBox/detail`);
// 获取电站列表
const getStubGroupList = postMock(`${Prefix}/stubGroup/list`);
// 更新桩的状态
const updateStubStatus = postMock(`${Prefix}/stub/statusSave`);

// 系统用户接口
const getDDuserList = postMock(`${Prefix}/user/ddUserList`);
const getUserList = postMock(`${Prefix}/user/userList`);
const getDepartmentList = getMock(`${Prefix}/user/ddDepartment/list`);
const getUserListFromDepartment = getMock(`${Prefix}/user/departmentUser/list`);
const addUserFromDing = postMock(`${Prefix}/user/departmentUser/add`);
// 用户角色
const getRoleList = postMock(`${Prefix}/user/role/List`);
const getPermissionList = postMock(`${Prefix}/permission/list`);
const deleteRole = postMock(`${Prefix}/role/del`);
const distributeRole = postMock(`${Prefix}/user/role/distribute`);

const editRole = postMock(`${Prefix}/edit/role`); // 新增或修改角色
const editPermission = postMock(`${Prefix}/edit/permission`);
const deletePermission = postMock(`${Prefix}/delete/permission`); // 删除权限

const orderHis = postMock(`${Prefix}/order/his`);
const powermoduleHis = postMock(`${Prefix}/powerModuleInfoSplitByOrder/orderHis`);

// 更获取枪端列表
const getEquipmentList = postMock(`${Prefix}/equipment/list`);

// 创建任务
const addTask = postMock(`${Prefix}/task/add`);

// 更新任务
const updateTask = postMock(`${Prefix}/task/update`);

// 获取协议配置属性
const getStubCfgInfo = postMock(`${Prefix}/stub/cfg`);

// 删除桩配置属性
const deleteStubCfg = postMock(`${Prefix}/stub/cfg/delete`);

// 获取任务列表
const getTaskList = postMock(`${Prefix}/task/list`);

// 删除任务
const deleteTask = postMock(`${Prefix}/task/delete`);

// 电桩配置参数查询
const stubCfgInfo = postMock(`${Prefix}/stub/cfg/info`);

// 电桩配置参数同步
const stubCfgSync = postMock(`${Prefix}/stub/cfg/sync`);
// 使用桩端配置
const cfgFromStub = postMock(`${Prefix}/cfg/from/stub`);
// 桩配置日志
const stubCfgRecord = postMock(`${Prefix}/stubCfgRecord`);
// 桩配置保存
const stubCfgSave = postMock(`${Prefix}/stubcfg/save`);

// 任务执行
const executeTask = postMock(`${Prefix}/task/execute`);

// 电桩配置操作履历
// const stubCfgRecord = postMock(Prefix + '/stub/cfg/record');

// 获取桩配置信息并封装返回给前端展示
const getStubCfgTableInfo = postMock(`${Prefix}/stub/cfg/tableInfo`);

// 获取任务执行后桩的配置结果
const getStubCfgResult = postMock(`${Prefix}/stub/cfg/result`);

// 命令下发
const stubCmd = postMock(`${Prefix}/stubCmd`);

// 获取充电订单详情
const getChargeOrderDetail = postMock(`${Prefix}/order/summary/detail`);

// 获取CRC异常列表
const getCRCExceptionList = postMock(`${Prefix}/crcExceptionStud`);

// 根据时间分组获取完好率数据
const geIntactRateByTimeDim = postMock(`${Prefix}/intactRate/geIntactRateByTimeDim`);

// 根据各维度获取设备完好率数据
const geIntactRateByTypeDim = postMock(`${Prefix}/intactRate/geIntactRateByTypeDim`);

// 根据各维度获取设备列表详情
const getStubListDetail = postMock(`${Prefix}/intactRate/stub/detail`);

// 模块列表页面
const powerModuleInfo = postMock(`${Prefix}/powerModuleInfo/list`);

// 故障上报页面
const stubErrorReport = postMock(`${Prefix}/stubFaultReported/list`);

// 事件监控页面
const monitoring = postMock(`${Prefix}/event/monitoring/list`);
// 故障等级
const stubFaultReportedlevelData = postMock(`${Prefix}/stubFaultReported/levelData`);

// 固件版本-获取升级履历  /stub/upgrade/log/list
const getUpgrade = postMock(`${Prefix}/stub/upgrade/log/list`);

// 固件版本-固件升级   /stub/upgrade
const upgrade = postMock(`${Prefix}/stub/upgrade`);

// 固件版本-获取桩固件信息  /stub/firmware/version/get
const getFirmwareVersion = postMock(`${Prefix}/stub/firmware/version/get`);

// 固件版本-获取固件类型  /stub/frameWork/list
const getFirmwareList = postMock(`${Prefix}/stub/frameWork/list`);
// 城市地区获取接口
const getCityList = postMock(`${Prefix}/city/list`);

// 电损  /api/electricalLoss/list
const electricalLoss = postMock(`${Prefix}/electricalLoss/list`);

// 设备完好率部分-查询天完好率 api/rate/day/get
const getRateDay = postMock(`${Prefix}/rate/day/get`);
// 设备完好率部分-查询月完好率 api/rate/month/get
const getRateMonth = postMock(`${Prefix}/rate/month/get`);
// 设备完好率部分-查询桩群完好率 api/stubgroup/rate/get
const getStubGroupRate = postMock(`${Prefix}/stubgroup/rate/get`);
// 设备完好率部分-查询桩完好率 api/stub/rate/get
const getStubRate = postMock(`${Prefix}/stub/rate/get`);
// 近2个月装群数据
const twoMonthStation = postMock(`${Prefix}/two/month/rate/get`);
// 设备完好率导出
const indicatorExport = postMock(`${Prefix}/indicator/export`);

/// 1.4.1新增

// 事件监控——告警详情 /event/monitoring/log/list
const eventMonitoringDetail = postMock(`${Prefix}/event/monitoring/log/list`);
// 模块信息，故障日志查询  /powerModule/status
const powerModuleStatus = postMock(`${Prefix}/powerModule/status`);

/// /1.5.0新增
// 停止原因接口 /api/endCodeInfo
const endCodeInfo = postMock(`${Prefix}/endCodeInfo`);
// 平台日志接口
const aliGetLogs = postMock(`${Prefix}/log/aliGetLogs`);
// 平台日志类型接口 /api/log/aliListLogstore
const aliListLogstore = postMock(`${Prefix}/log/aliListLogstore`);
// 充电应用 /appKeyInfo
const appKeyInfo = postMock(`${Prefix}/appKeyInfo`);

// 1.5.0 看板接口
// 长期异常桩 /stubLongAbnormalList
const stubLongAbnormalList = postMock(`${Prefix}/stubLongAbnormalList`);

// 1:设备数据 /equipment/quantity/qry
const equipmentQry = postMock(`${Prefix}/equipment/quantity/qry`);
// 2:充电成功率 /success/rate/quantity/qry
const successQry = postMock(`${Prefix}/success/rate/quantity/qry`);
// 2：充电成功率 柱状图  /success/rate/trend/qry
const successRateQry = postMock(`${Prefix}/success/rate/trend/qry`);
// 3: 设备完好率 数据 equipment/intact/rate/quantity/qry
const intactRry = postMock(`${Prefix}/equipment/intact/rate/quantity/qry`);
// 3: 设备完好率 趋势 equipment/intact/rate/trend/qry
const intacttrend = postMock(`${Prefix}/equipment/intact/rate/trend/qry`);
// 4:电损数据查询  power/loss/quantity/qry
const powerlossQry = postMock(`${Prefix}/power/loss/quantity/qry`);
// 4:电损趋势查询
const powerlossTrend = postMock(`${Prefix}/power/loss/trend/qry`);
// 5:事件数据查询
const eventMonitoringQry = postMock(`${Prefix}/event/monitoring/quantity/qry`);
// 5:事件趋势查询
const eventMonitoringTrend = postMock(`${Prefix}/event/monitoring/trend/qry`);
// 6:故障数量查询
const faultQry = postMock(`${Prefix}/fault/report/quantity/qry`);
// 7:故障趋势查询
const faultTrend = postMock(`${Prefix}/fault/report/trend/qry`);
// 仓库设备信息查询列表
const getDepotStubInfoList = getMock(`${Prefix}/stub/depot/stubInfoList`);
// 查询信号历史记录
const getSignalHistory = getMock(`${Prefix}/stub/signal`);
// 查询状态码列表
const getStatusCodeList = getMock(`${Prefix}/status/code/list`);
// 更新状态码信息
const updateStatusCodeInfo = postMock(`${Prefix}/status/code`);
// 查询字典值
const getDicCodeList = getMock(`${Prefix}/dic/code/list`);
// 按月查询充电成功率趋势
const getChargeSuccessRateByMon = getMock(`${Prefix}/city/month/charge/success/rate`);
// 按天查询充电成功率趋势
const getChargeSuccessRateByDay = getMock(`${Prefix}/city/day/charge/success/rate`);
// 固件版本维度充电成功率趋势
const getChargeSuccessRateByFirmware = getMock(`${Prefix}/versiontype/charge/success/rate`);
// 地区维度停止原因占比
const getStopReason = getMock(`${Prefix}/endcode/city/charge/success/perc`);
// 设备充电成功率排行
const getStationOrEquRank = getMock(`${Prefix}/stub/charge/success/rank`);
// 电站充电成功率排行
const getStationRank = getMock(`${Prefix}/stubgroup/charge/success/rank`);

// 渠道排行
const getChanelRank = getMock(`${Prefix}/appkey/charge/success/rank`);
// 电站充电成功率趋势
const getStationSuccessRate = getMock(`${Prefix}/stubgroup/charge/success/rate`);
// 设备充电成功率趋势
const getEquSuccessRate = getMock(`${Prefix}/stub/charge/success/rate`);
// 电站设备维度停止原因
const getStationOrEquStopReason = getMock(`${Prefix}/endcode/stub/charge/success/perc`);
// 设备诊断
const stubDiagnosis = getMock(`${Prefix}/diagnosis/stub`);
// 电站诊断
const stubGroupDiagnosis = getMock(`${Prefix}/diagnosis/stubgroup`);

// 电损系数更新
const electricalLossUpdate = postMock(`${Prefix}/stub/elecloss/update`);

// 固件备注更新
const updateFirmwareRemark = postMock(`${Prefix}/stub/firmware/updateFirmwareInfo`);
// 版本信息列表
const getVersionList = getMock(`${Prefix}/stub/firmware/version/list`);
// 固件状态操作
const updateFirmwareStatus = postMock(`${Prefix}/stub/firmware/version/update`);
// 新增固件型号和版本
const addFirmware = postMock(`${Prefix}/stub/firmware/version/save`);
// 获取固件型号列表
const getFirmwareList1 = getMock(`${Prefix}/stub/firmware/list`);
// 获取固件升级进度
const getFirmwareUpdateProgress = getMock(`${Prefix}/stub/firmware/version/get`);
// 1.7.0 新增接口
// 设备快速查询
// 远程复位
const stubRestart = getMock(`${Prefix}/stubRestart`);
// 电站名称筛选
const stubGroupNameSearch = getMock(`${Prefix}/stubGroupByName/list`);
// 电站拓扑图列表
const stubGroupRelation = getMock(`${Prefix}/stubgroup/relation/list`);
// 获取最新固件版本号
const stubCmdFirmware = getMock(`${Prefix}/stubCmdFirmware`);
// 事件监控——新
const stubEventMonitoringNew = getMock(`${Prefix}/stub/event/monitoring/list`);
// 事件监控详情——新
const stubEventMonitoringDetailNew = getMock(`${Prefix}/stub/event/monitoring/log/list`);
// 修改事件状态
const eventStatusChange = getMock(`${Prefix}/stub/event/status/change`);
// 基础信息
const stubDetailInfoApi = getMock(`${Prefix}/stub/detail`);
// 1.8.0 新增部分
// 订单强制停止
const orderForceStop = getMock(`${Prefix}/order/orderForceStop`);

// 上传文件
const uploadFileApi = postMock(`${prefixFile}/uploadFile.do`);
// 校验鉴权文件 api/stubcfg/filecrc/check
const checkJQfile = getMock(`${Prefix}/stubcfg/filecrc/check`);

export {
  getUserMenuList,
  getChargSuccessCityType,
  getChargSuccessCity,
  getStubOperationModeList,
  getStubCitySuccessRateList,
  getAppkeySuccessRate,
  getChargSuccessVersionType,
  getChargSuccessEndCode,
  getDepartmentList,
  getUserListFromDepartment,
  addUserFromDing,
  getUserList,
  getPowerBoxList,
  getPowerBoxDetail,
  getRoleList,
  getPermissionList,
  deleteRole,
  editRole,
  prefixFile,
  cancelReqs,
  getDDuserList,
  distributeRole,
  getFrameWorkList,
  getModelNoList,
  getUpdateTypeList,
  getStubInfoList,
  getStubStatuLogList,
  editPermission,
  getStubOrderDetailInfo,
  getStubGroupList,
  getStubOrderInfoList,
  orderHis,
  powermoduleHis,
  updateStubStatus,
  getEquipmentList,
  addTask,
  getStubCfgInfo,
  updateTask,
  deleteStubCfg,
  getTaskList,
  deleteTask,
  stubCfgInfo,
  stubCfgSync,
  cfgFromStub,
  stubCfgRecord,
  stubCfgSave,
  executeTask,
  getStubCfgTableInfo,
  getStubCfgResult,
  stubCmd,
  getChargeOrderDetail,
  getCRCExceptionList,
  geIntactRateByTimeDim,
  geIntactRateByTypeDim,
  getStubListDetail,
  stubErrorReport,
  monitoring,
  stubFaultReportedlevelData,
  powerModuleInfo,
  getUpgrade,
  upgrade,
  getFirmwareVersion,
  getFirmwareList,
  deletePermission,
  getCityList,
  electricalLoss,
  getRateDay,
  getRateMonth,
  getStubGroupRate,
  getStubRate,
  twoMonthStation,
  indicatorExport,
  eventMonitoringDetail,
  powerModuleStatus,
  endCodeInfo,
  aliListLogstore,
  aliGetLogs,
  appKeyInfo,
  equipmentQry,
  successQry,
  successRateQry,
  intactRry,
  intacttrend,
  powerlossQry,
  powerlossTrend,
  eventMonitoringQry,
  eventMonitoringTrend,
  faultQry,
  faultTrend,
  stubLongAbnormalList,
  getDepotStubInfoList,
  getSignalHistory,
  getStatusCodeList,
  updateStatusCodeInfo,
  getDicCodeList,
  getChargeSuccessRateByMon,
  getChargeSuccessRateByDay,
  getChargeSuccessRateByFirmware,
  getStopReason,
  getStationOrEquRank,
  getChanelRank,
  getStationSuccessRate,
  getEquSuccessRate,
  getStationOrEquStopReason,
  stubDiagnosis,
  stubGroupDiagnosis,
  getStationRank,
  electricalLossUpdate,
  updateFirmwareRemark,
  getVersionList,
  updateFirmwareStatus,
  addFirmware,
  getFirmwareList1,
  getFirmwareUpdateProgress,
  stubRestart,
  stubGroupNameSearch,
  stubGroupRelation,
  stubCmdFirmware,
  stubEventMonitoringNew,
  stubEventMonitoringDetailNew,
  eventStatusChange,
  stubDetailInfoApi,
  orderForceStop,
  uploadFileApi,
  checkJQfile,
};



// WEBPACK FOOTER //
// ./src/AntD/fetch/fetchApi.js